import { Component, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStoreService } from '@frontend-site/shared/core';

@Component({
    selector: 'ai-consent-dialog',
    template: `
        <p-dialog-container class="container">
            <img class="icon" [src]="'assets/img/illustrations-big.svg'" />
            <p-dialog-header class="header" title="{{ 'AiConsent.titleMessage' | translate }}"></p-dialog-header>
            <div class="p-dialog-content" [formGroup]="form">
                <p class="p-paragraph-1 row1" innerHtml="{{ 'AiConsent.bodyMessage1' | translate }}"></p>
                <p class="p-paragraph-1 row2" innerHtml="{{ 'AiConsent.bodyMessage2' | translate }}"></p>
                <p class="p-paragraph-1 row3" innerHtml="{{ 'AiConsent.bodyMessage3' | translate }}"></p>
            </div>
            <p-field-checkbox
                class="p-paragraph-1 row4"
                clickableLabel="{{ 'AiConsent.bodyMessage4' | translate }}"
                (viewValueChanged)="dontShowAgainClicked($event)"
            >
            </p-field-checkbox>

            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./ai-consent-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiConsentDialogComponent implements OnDestroy {
    form: UntypedFormGroup = this.fb.group({});
    constructor(
        private localStorage: LocalStoreService,
        public dialogRef: MatDialogRef<string>,
        private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA)
        public data: { storagekey: string; systemId: number }
    ) {}

    get footerConfig() {
        return [
            {
                click: () => this.dialogRef.close(true),
                text: 'Actions.aiEnable'
            },
            {
                click: () => this.noThankYouClicked(),
                text: 'Actions.aiDisable'
            }
        ];
    }

    noThankYouClicked() {
        sessionStorage.setItem(this.data.storagekey, 'true');
        this.dialogRef.close(false);
    }

    dontShowAgainClicked(value: boolean) {
        value ? this.localStorage.saveData(this.data.storagekey, 'true') : this.localStorage.removeData(this.data.storagekey);
    }

    ngOnDestroy(): void {
        if (sessionStorage.getItem(this.data.storagekey) == null) sessionStorage.setItem(this.data.storagekey, 'true');
    }
}
